export default {
    getAllSDM18MVRs: () => {
        return {
            url: '/myfhe/SDM18MVRs',
            method: 'GET'
        };
    },
    getSDM18MVRDetails: SDM18MVRId => {
        return {
            url: '/myfhe/SDM18MVRs/:SDM18MVRId',
            method: 'GET',
            route_params: {
                SDM18MVRId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18MVR/api.js